import React from "react";
import SubTitle from "../../components/SubTitle";
import ArticleSubTitle from "../../components/articles/ArticleSubTitle";

const IndexSection = ({ title, titleJP, subtitles, items, bottomText, bottomTextJP, selectedTag, onSelectTag }) => {
  return (
    <div className="article-view-section">
      <div className="container article-view-main index-section">
            <div className="article-title-view">
                <div className="left-section">
                    {/* Section Header */}
                    <SubTitle title={title} subTitle={titleJP} />

                    {/* Subtitles (Left-view) */}
                    <div className="left-view">
                    {subtitles?.map((sub, index) => (
                        <p key={index} className="text1 font-amaticsc-bold">
                        {index + 1}. {sub.subtitle} /{" "}
                        <span className="text2 font-zenkurenaido">{sub.subtitleJP}</span>
                        </p>
                    ))}
                    </div>

                    {/* Optional bottom lines */}
                    <hr className="bottom-line" />
                    <hr className="bottom-line" />
                </div>

                {/* Right section: dynamic items (clickable tag filters) */}
                <div className="right-section align-top">
                    {items?.map((item, index) => (
                    <ArticleSubTitle
                        key={index}
                        title={item.title}
                        subTitle={item.titleJP}
                        textColor={item.textColor}
                        link={item.link} // optional
                        onClick={onSelectTag ? () => onSelectTag(item.title) : undefined}
                        isActive={selectedTag === item.title}
                    />
                    ))}
                </div>

                {/* Optional section-level bottom text */}
                {(bottomText || bottomTextJP) && (
                    <div className="section-bottom-text">
                    {bottomText} / {bottomTextJP}
                    </div>
                )}
            </div>

            {/* Article Archive...
            <div className="article-item-view">
                {items.map((item, i) => {
                    return (
                    <ArticleItem
                        key={i + 1}
                        title_en={item.title}
                        title_jp={item.titleJP}
                        tags={item.tags} // dynamic array of tags
                        content={item.paragraph}
                        type={i % 2 === 1} // ✅ true for every 2nd item (1, 3, 5…)
                    />
                    );
                })}
            </div> */}
        </div>
    </div>  
  );
};

export default IndexSection;